<template>
    <div :class="classes">
        <div class="v-input__control">
            <div class="v-input__slot">
                <fieldset aria-hidden="true">
                    <legend style="width: 0px"><span></span></legend>
                </fieldset>
                <div class="v-text-field__slot">
                    <gmap-autocomplete v-bind="$attrs" v-on="$listeners">
                        <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
                            <slot :name="slot" v-bind="scope"></slot>
                        </template>
                    </gmap-autocomplete>
                </div>
            </div>
            <div class="v-text-field__details">
                <div class="v-messages theme--light">
                    <slot name="error"></slot>
                    <div class="v-messages__wrapper">
                        {{ hint }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        outlined: {
            type: Boolean,
            required: false,
            default: false,
        },
        dense: {
            type: Boolean,
            required: false,
            default: false,
        },
        hint: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            classes: {
                'v-input': true,
                'v-input--dense': this.dense,
                'theme--light': true,
                'v-text-field': true,
                'v-text-field--is-booted': true,
                'v-text-field--enclosed': true,
                'v-text-field--outlined': this.outlined,
            },
        };
    },
};
</script>

<style scoped></style>
